import React, { Component } from 'react';
import startsWith from 'lodash/startsWith';
import get from 'lodash/get';
import { createComponent, customMap } from 'redux-form-antd';
import { Upload, Icon, notification, Button } from 'antd';
import ImageLoader from '../../atoms/ImageLoader';

class UploadDialog extends Component {
  state = {
    fileList: [],
    loading: false,
    imageUrl: false,
  };

  componentDidMount() {
    if (this.props.value) {
      this.setState({ imageUrl: this.props.value });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value && !this.props.value) {
      this.setState({ imageUrl: null });
    }

    if (!prevProps.value && this.props.value) {
      this.setState({ imageUrl: this.props.value });
    }
  }

  getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  getImageUrl = responseUrl =>
    // Save the filename only when doing checkpoint uploads
    startsWith(responseUrl, 'http')
      ? responseUrl.replace(process.env.REACT_APP_IMAGE_LOCATION, '')
      : responseUrl;

  beforeUpload = file => {
    let isImage = file.type === 'image/png' || file.type === 'image/gif';
    let imageTypeError = 'You can only upload PNG or GIF files';

    // Product images can't upload jpeg
    if (get(this.props, 'action', '').indexOf('/product/upload') === -1) {
      isImage = isImage || file.type === 'image/jpeg';
      imageTypeError = 'You can only upload PNG, JPG, and GIF files';
    }

    if (!isImage) {
      notification.error({ message: 'Error', description: imageTypeError, duration: 0 });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification.error({
        message: 'Error',
        description: 'Image must smaller than 2MB!',
        duration: 0,
      });
    }

    if (!isImage || !isLt2M) {
      this.setState({ loading: false, imageUrl: null });
    }

    return isImage && isLt2M;
  };

  handleChange = info => {
    let { fileList } = info;

    // 1. Limit the number of uploaded files
    //    Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. read from response and show file link
    fileList = fileList.map(file => {
      if (file.response) {
        // Component will show file.url as link
        file.url = this.getImageUrl(file.response.url_image);
      }
      return file;
    });

    // 3. filter successfully uploaded files according to response from server
    fileList = fileList.filter(file => {
      if (file.response) {
        return !!file.response.id;
      }
      return true;
    });

    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    }

    if (info.file.status === 'error') {
      const err = get(info, 'file.response.error', 'Image could not be uploaded.');
      notification.error({ message: 'Error', description: err, duration: 0 });

      this.setState({
        imageUrl: null,
        loading: false,
      });
    }

    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.getBase64(info.file.originFileObj, imageUrl =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );

      // Call the redux-form dispatch
      this.props.onChange(this.getImageUrl(info.file.response.url_image));
      notification.success({ message: 'Success', description: 'File uploaded', duration: 4 });
    }

    this.setState({ fileList });
  };

  remove = () => {
    this.props.onChange('');
    return this.setState({ loading: false, imageUrl: null });
  };

  render() {
    const { imageUrl, fileList, loading } = this.state;
    const { token } = JSON.parse(localStorage.getItem('user'));

    let { name } = this.props;

    // Strip name on the upload
    if (name.indexOf('creative_image') > 2) {
      name = 'creative_image';
    }

    return (
      <>
        <Upload
          name={name}
          className="image-uploader"
          showUploadList
          fileList={fileList}
          onRemove={this.remove}
          action={this.props.action}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          headers={{
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }}
        >
          <div style={{ marginBottom: 10 }}>
            <Button>
              <Icon type={loading ? 'loading' : 'upload'} />{' '}
              {`Upload ${imageUrl ? 'new' : ''} image`}
            </Button>
            {imageUrl && (
              <Button type="link" onClick={this.remove}>
                Remove this image
              </Button>
            )}
          </div>
          {imageUrl && (
            <ImageLoader
              style={{ maxWidth: 320, width: 'auto', margin: '0 auto' }}
              src={imageUrl}
            />
          )}
        </Upload>
      </>
    );
  }
}

// redux-form mapper
function mapUploadDialog(
  mapProps,
  { input: { value: omitValue, onChange, onBlur, ...inputProps }, meta: omitMeta, ...props }
) {
  return {
    ...mapProps,
    onChange,
    onBlur,
  };
}
const UploadDialogMap = createComponent(UploadDialog, customMap(mapUploadDialog));

export default UploadDialogMap;
